import { CloseIcon } from 'components/Drawer';
import ThreeStars from 'components/icons/outline/ThreeStars';
import Spinner from 'components/Spinner';
import { cn } from 'components/utils';
import { useTranslation } from 'react-i18next';
import { MedicalReportStatus } from 'state/medicalReports/index.slice';

export interface AutomaticHeaderProps {
  currentAutomaticStatus: MedicalReportStatus;
}

const AutomaticHeader = ({ currentAutomaticStatus }: AutomaticHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'p-1 bg-purple-light text-primary-dark mt-2 mx-4 rounded-full px-3 w-fit -translate-x-4 -translate-y-3',
        {
          'bg-negative-light text-negative-dark':
            currentAutomaticStatus === 'error',
          hidden: currentAutomaticStatus === 'idle',
        },
        'flex flex-row gap-2 items-center'
      )}
    >
      {{
        idle: null,
        error: <CloseIcon className="w-2.5" />,
        active: <ThreeStars className="w-4" />,
        loading: <Spinner className="w-3" />,
        finished: <ThreeStars className="w-4" />,
        cancelled: <CloseIcon className="w-2.5" />,
      }[currentAutomaticStatus] ?? null}

      <p className="text-xs">
        {t(`reports__automatic_message_${currentAutomaticStatus}_title`)}
      </p>
    </div>
  );
};

export default AutomaticHeader;
